import {
    IRegulationLinkNavigationHook,
    IRegulationLinkNavigationHookResult,
    RegulationNavigationHookContinuationMode
} from "./regulation-link-navigation-hook.interface";
import {INavigateLinkOptions} from "../links-navigation.service.interface";

export class RegulationNavigationHookBase implements IRegulationLinkNavigationHook {
    async navigateLink(options: INavigateLinkOptions): Promise<IRegulationLinkNavigationHookResult> {
        return {
            continuationMode: RegulationNavigationHookContinuationMode.Continue
        };
    }

}